<template>
  <b-alert show variant="warning" v-if="canShowAlert()">
    <div class="lyon-display-medium-18 alert-heading mb-1">
      {{ hasPolicyUpdates() ? "We have updated our policy. Please agree to the latest changes:" : "You must accept our policy agreements:" }}
    </div>
    <div v-for="(policy, key) in policyMapping" :key="key" class="medium-14 mb-2">
			<div v-if="shouldShowPolicy(key)">
				<button class="btn btn-primary btn-sm" @click="updatePolicy(key)">
					I agree
				</button>
				<span>to the</span>
				<a :href="policy.url" target="_blank" class="alert-link">{{ policy.label }}</a>
			</div>
    </div>
  </b-alert>
</template>

<script>
export default {
	name: "PolicyAgreementSection",
	props: ["data", "eventType", "eventName"],
	data() {
		return {
			policyMapping: {
				"privacy-policy": {
					label: "Privacy Policy",
					url: "/privacy-policy",
					agreedKey: "agree_to_privacy_policy",
					latestKey: "is_agreed_to_latest_privacy_policy",
				},
				"anti-discrimination-and-harassment-policy": {
					label: "Harassment Policy",
					url: "/anti-discrimination-and-harassment-policy",
					agreedKey: "agree_to_harassment_policy",
					latestKey: "is_agreed_to_latest_harassment_policy",
				},
				"collegiality-statement": {
					label: "Collegiality Statement",
					url: "/collegiality-statement",
					agreedKey: "agree_to_collegiality_statement",
					latestKey: "is_agreed_to_latest_collegiality_statement",
				},
			},
		}
	},
	methods: {
		shouldShowPolicy(key) {
			const policy = this.policyMapping[key]
			return !this.data[policy.agreedKey] || !this.data[policy.latestKey]
		},
		canShowAlert() {
			return this.data.is_owner && Object.keys(this.policyMapping).some((key) => this.shouldShowPolicy(key))
		},
		hasPolicyUpdates() {
			return this.data.requires_latest_policy_agreement_message
		},
		updatePolicy(type) {
			this.$http
				.patch(`${process.env.VUE_APP_API_URL}/policy_agreements/${type}`, {
					event_type: this.eventType,
					event_name: this.eventName,
				})
				.then((res) => {
					if (res) {
						if (res.data.error) {
							this.$toasted.global.error(res.data.error)
						} else if (res.status === 403) {
							this.$toasted.global.error("Please sign in again")
						} else {
							this.$toasted.global.success(res.data.message)
							// Update both agreedKey and latestKey to true
							const policy = this.policyMapping[type]
							this.$set(this.data, policy.latestKey, true)
							this.$set(this.data, policy.agreedKey, true)
						}
					}
				})
		},
	},
}
</script>